import { Component, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import { DxSchedulerComponent } from 'devextreme-angular/ui/scheduler';
import { dxEvent } from 'devextreme/events';
import { dxDateBoxOptions } from 'devextreme/ui/date_box';
import notify from 'devextreme/ui/notify';
import dxScheduler, { dxSchedulerAppointment } from 'devextreme/ui/scheduler';
import { compact, isNil } from 'lodash-es';
import head from 'lodash-es/head';
import isEmpty from 'lodash-es/isEmpty';
import last from 'lodash-es/last';
import moment, { utc } from 'moment/moment';
import { combineLatest, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { oc } from 'ts-optchain';
import { DxComponentEvent, DxFieldDataChangedEvent } from '../../../../core/dx.types';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { ABaseComponent } from '../../../../shared/modules/ui/components/abstract/a-base.component';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { ActiveClientSignatureView, AuthServiceApi, Consumer, LoggerService } from '../../../../shared/sdk';
import { AuthClaimService } from '../../services/auth-claim.service';
import {
  IAuthMember,
  IClaimData,
  INavinetAuthDoc,
  IStediE9yDoc,
  TAppMealClaimSet,
} from '../../services/auth-claim.type';
import { EditClaimService } from '../../services/edit-claim.service';

type TServiceLine = IClaimData['services'][0];
type TAppointment = dxSchedulerAppointment & { data?: TServiceLine };

@Component({
  selector: 'app-dlg-edit-claim-v2',
  templateUrl: './dlg-edit-claim-v2.component.html',
  styleUrls: ['./dlg-edit-claim-v2.component.scss'],
  providers: [AuthClaimService, EditClaimService],
})
export class DlgEditClaimV2Component extends ABaseComponent implements OnInit {
  constructor(
    protected logger: LoggerService,
    private dss: DataSourceService,
    private ui: UiService,
    private api: AuthServiceApi,
    public config: ConfigService,
    private authClaimService: AuthClaimService,
    private editClaimService: EditClaimService,

    private dialogRef: MatDialogRef<DlgEditClaimV2Component, any>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      date: Date;
      authId: string;
      member: IAuthMember;
      cells: { startDate: Date }[];
    },
  ) {
    super(logger);
    // console.log(data);
  }

  get rate() {
    return oc(this.claimData).rate(this.initRate);
  }

  get inputMoment() {
    return moment(this.data.date);
  }

  get month() {
    return this.inputMoment.startOf('month').format('YYYYMM');
  }

  get minDate() {
    return this.inputMoment.startOf('month').toDate();
  }

  get maxDate() {
    return this.inputMoment.endOf('month').toDate();
  }

  get mco() {
    return oc(this.data).member.eligibility.mco();
  }

  get payerId() {
    return {
      'KEYSTONE VIP': '77741',
      KEYSTONE: '42344',
      PHW: '68069',
      UPMC: '23281',
      AMERIHEALTH: '22248',
    }[this.mco];
  }

  get lastClaim() {
    return last(oc(this.claimSet).claimStack([]));
  }

  // get dates() {
  //   const selectedDates = sortBy(
  //     oc(this.data)
  //       .cells([])
  //       .map(c => moment(c.startDate).format('YYYY-MM-DD')),
  //     identity,
  //   );
  //
  //   if (selectedDates.length > 1) return selectedDates;
  //
  //   const date = this.inputMoment.format('YYYY-MM-DD');
  //
  //   const som = utc(date).startOf('month').format('YYYY-MM-DD');
  //   const eom = utc(date).endOf('month').format('YYYY-MM-DD');
  //
  //   const asd = this.auth ? utc(this.auth.StartDT).format('YYYY-MM-DD') : undefined;
  //   const aed = this.auth ? utc(this.auth.EndDT).format('YYYY-MM-DD') : undefined;
  //
  //   return [last(sortBy(compact([asd, som]), identity)), head(sortBy(compact([aed, eom]), identity))];
  // }

  claimData: IClaimData;
  auth: INavinetAuthDoc;
  authDateUnits: Map<string, number> = new Map();
  signsDateUnits: Map<string, number> = new Map();
  consumer?: Partial<Consumer>;
  signs?: ActiveClientSignatureView[];
  e9yDoc?: IStediE9yDoc;
  claimSet?: TAppMealClaimSet;
  navinetClaims?: Record<string, any>[];
  initRate: number;
  correctionType: 'new' | 'adjust' | 'void';
  appointments: TAppointment[] = [];

  @ViewChild('form', { static: false }) form: DxFormComponent;
  @ViewChildren('lineForm') lineForms!: QueryList<DxFormComponent>;
  @ViewChild('claimScheduler', { static: false }) scheduler: DxSchedulerComponent;

  public payerLabel: any;
  public authLabel: any;
  isTest = false;

  serviceLineDateOptions: dxDateBoxOptions = {
    type: 'date',
    dateSerializationFormat: 'yyyy-MM-dd',
    displayFormat: 'shortDate',
    min: this.minDate,
    max: this.maxDate,

    disabledDates: data => {
      const date = this.inputMoment.format('YYYY-MM-DD');
      const dateSet = new Set(compact(this.claimData.services.map(sl => sl.serviceDate)));
      return dateSet.has(date);
    },
  };

  ngOnInit() {
    this.resetForm();
  }

  private buildForm$() {
    return combineLatest([
      this.editClaimService.getAuth$(oc(this.data).authId()),
      this.editClaimService.getConsumer$(oc(this.data).member.c.id()),
      this.editClaimService.getClaimSet$(oc(this.data).authId(), +this.month),
    ]).pipe(
      switchMap(([auth, cons, claimSet]) =>
        combineLatest([
          of(null),
          // this.getE9yDoc$(claimSet),
          this.editClaimService.getMemberSigns$(auth._mci, +this.month),
          this.api.getRate(this.inputMoment.format('YYYY-MM-DD'), oc(auth).Code()),
          this.editClaimService.getNavinetClaims$(auth),
        ]).pipe(
          map(([e9yDoc, signs, rate, navinetClaims]) => ({ auth, cons, signs, claimSet, e9yDoc, rate, navinetClaims })),
        ),
      ),
      tap(({ auth, cons, signs, claimSet, e9yDoc, rate, navinetClaims }) => {
        this.auth = auth;
        this.consumer = cons;
        this.signs = signs;
        // this.e9yDoc = e9yDoc;
        this.claimSet = claimSet;
        this.navinetClaims = navinetClaims;
        this.initRate = rate;
      }),
      tap(() => {
        // const memberCl = oc(this.data.member)
        //   .claims([])
        //   .find(cl => cl.auth._id === this.auth._id);

        {
          const dates = this.authClaimService
            .getAuthRRule(this.auth)
            .between(
              utc(moment(this.minDate).format('YYYY-MM-DD')).hours(12).toDate(),
              utc(moment(this.maxDate).format('YYYY-MM-DD')).hours(12).toDate(),
              true,
            )
            .map(d => moment(d).format('YYYY-MM-DD'));

          this.authDateUnits = new Map(dates.map(d => [d, this.authClaimService.getUnitsByDates([this.auth], [d])]));
        }

        {
          const _map2 = {
            HOT: 'W1759',
            FROZEN: 'W1760',
            SANDWICH: 'W1761',
            EMERGENCY: 'W1762',
            SPECIAL: 'W1764',
          };

          for (const s of this.signs) {
            Object.entries<number>(s.meta.mealDroppedCountList)
              .filter(([k, v]) => this.auth.Code === oc(_map2[k])(k))
              .filter(([k, v]) => !isNil(v) && v > 0)
              .forEach(([k, v]) => this.signsDateUnits.set(s.vdate, oc(v)(0)));
          }
        }

        this.payerLabel =
          'Preselected Payer [' +
          this.mco +
          // || [oc(this.e9yDoc).response.tradingPartnerServiceId(), oc(this.e9yDoc).response.payer.name()].join(' | ')
          ']';

        this.authLabel =
          'Preselected Auth [' +
          [
            oc(this.auth).AuthNumberFacets(),
            utc(oc(this.auth).StartDT()).format('L') + '-' + utc(oc(this.auth).EndDT()).format('L'),
            oc(this.auth).AuthUnitsApproved(),
          ].join(' | ') +
          ']';

        const clReq = oc(this.lastClaim).request();
        const clMember = oc(clReq).subscriber();

        const e9yResp = oc(this.e9yDoc).response();
        const e9yMember = oc(e9yResp).subscriber();

        // const anyE9yResp = oc(this.getActiveE9yDocs())[0].response();
        // const anyE9yMember = oc(anyE9yResp).subscriber();

        this.claimData = {
          claimId: oc(this.claimSet)._id(),

          correction: {
            claimControlNumber:
              oc(last(oc(this.navinetClaims)([]))).ClaimID() ||
              oc(last(oc(this.lastClaim)['277ca']([]))).claimStatus.tradingPartnerClaimNumber(),
            // || oc(this.lastClaim).statusClaimID(),
          },

          authId: oc(this.claimSet).auth._id() || oc(this.auth)._id(),

          authID:
            oc(clReq).claimInformation.claimSupplementalInformation.priorAuthorizationNumber() ||
            oc(this.claimSet).auth.AuthNumberFacets() ||
            oc(this.auth).AuthNumberFacets(),

          payerID: oc(clReq).tradingPartnerServiceId() || this.payerId || oc(this.e9yDoc).e9y(),

          procedureCode:
            oc(clReq).claimInformation.serviceLines[0].professionalService.procedureCode() ||
            oc(this.claimSet).auth.Code() ||
            oc(this.auth).Code(),

          rate: this.initRate,
          chargeAmount: Number(oc(clReq).claimInformation.claimChargeAmount() || 0),

          subscriber: {
            mci: oc(this.claimSet).auth._mci() || oc(this.auth)._mci() || oc(this.consumer).mci(),
            memberID:
              oc(clMember).memberId() ||
              oc(e9yMember).memberId() ||
              // oc(anyE9yMember).memberId() ||
              oc(this.auth).MemberID(),
            firstname:
              oc(clMember).firstName() ||
              oc(e9yMember).firstName() ||
              // oc(anyE9yMember).firstName() ||
              oc(this.auth).FirstName() ||
              oc(this.consumer).person.firstname(),
            lastname:
              oc(clMember).lastName() ||
              oc(e9yMember).lastName() ||
              // oc(anyE9yMember).lastName() ||
              oc(this.auth).LastName() ||
              oc(this.consumer).person.lastname(),
            gender: oc(clMember).gender() || oc(e9yMember).gender() || (oc(this.consumer).person.sex() as any),
            // || oc(anyE9yMember).gender()
            dob: head(
              compact([
                oc(clMember).dateOfBirth(),
                oc(e9yMember).dateOfBirth(),
                // oc(anyE9yMember).dateOfBirth(),
                oc(this.auth).MemberDOB(),
                oc(this.consumer).person.dob(),
              ]).map(d => moment(d, ['YYYYMMDD', 'YYYY-MM-DD']).format('YYYY-MM-DD')),
            ),
          },

          address: {
            address1:
              oc(e9yMember).address.address1() ||
              // oc(anyE9yMember).address.address1() ||
              oc(this.claimSet).consumer.person.contact.addresses[0].street() ||
              oc(this.consumer).person.contact.addresses[0].street(),
            address2: oc(e9yMember).address.address2(),
            // || oc(anyE9yMember).address.address2()
            city:
              oc(e9yMember).address.city() ||
              // oc(anyE9yMember).address.city() ||
              oc(this.claimSet).consumer.person.contact.addresses[0].city() ||
              oc(this.consumer).person.contact.addresses[0].city(),
            state:
              oc(e9yMember).address.state() ||
              // oc(anyE9yMember).address.state() ||
              oc(this.claimSet).consumer.person.contact.addresses[0].state() ||
              oc(this.consumer).person.contact.addresses[0].state(),
            zip:
              oc(e9yMember).address.postalCode() ||
              // oc(anyE9yMember).address.postalCode() ||
              oc(this.claimSet).consumer.person.contact.addresses[0].zip() ||
              oc(this.consumer).person.contact.addresses[0].zip(),
          },

          services: oc(clReq)
            .claimInformation.serviceLines([])
            .map(sl => {
              return {
                serviceDate: oc(sl).serviceDate(),
                serviceDateEnd: oc(sl).serviceDateEnd(),

                unitCount:
                  oc(sl).professionalService.serviceUnitCount() ||
                  oc(this.claimSet).meta.authUnits() ||
                  oc(this.auth).AuthUnitsApproved() ||
                  0,
                chargeAmount: Number(oc(sl).professionalService.lineItemChargeAmount() || 0),
              };
            }),
        };
      }),
    );
  }

  /////////////////////////////

  // region service line forms

  addLineGroup() {
    this.claimData.services.push({
      // serviceDate: '',
      // serviceDateEnd: '',
      unitCount: 1,
      chargeAmount: this.rate,
    });

    this.recalcFormsValues();
  }

  removeLineGroup(idx: number) {
    this.claimData.services.splice(idx, 1);

    this.recalcFormsValues();
    this.buildAppointmentsFromLines();
  }

  onFieldDataChanged(e: DxFieldDataChangedEvent) {
    console.log('onFieldDataChanged', e);

    if (['rate'].includes(e.dataField)) {
      this.recalcFormsValues();
      this.buildAppointmentsFromLines();
    }
  }

  service_onFieldDataChanged(e: DxFieldDataChangedEvent) {
    console.log('service_onFieldDataChanged', e);

    if (['serviceDate', 'serviceDateEnd', 'unitCount'].includes(e.dataField)) {
      this.recalcFormsValues();
      this.buildAppointmentsFromLines();
    }
  }

  // endregion

  //

  buildAppointmentsFromLines() {
    this.appointments = this.claimData.services.map(sl => this.buildAppointment(sl));
  }

  buildAppointmentsFromAuth() {
    this.appointments = Array.from(this.authDateUnits.entries()).map(([d, u]) => {
      const sl: TServiceLine = {
        serviceDate: moment(d).format('YYYY-MM-DD'),
        unitCount: u,
        chargeAmount: +(this.rate * u).toFixed(2),
      };

      return this.buildAppointment(sl);
    });

    this.buildLinesFromAppointments();
  }

  scheduler_onCellClick(e: DxComponentEvent<dxScheduler> & { cancel: boolean; cellData: { startDate: Date } }) {
    console.log('scheduler_onCellClick', e);

    e.cancel = true;

    const date = moment(e.cellData.startDate).format('YYYY-MM-DD');
    this.createAppointment(date);
  }

  scheduler_onAppointmentFormOpening(e: { appointmentData: TAppointment; cancel: boolean }) {
    console.log('scheduler_onAppointmentFormOpening', e);

    e.cancel = true;

    // const date = moment(e.appointmentData.startDate).format('YYYY-MM-DD');
  }

  scheduler_onAppointmentDblClick(e: { appointmentData: TAppointment; cancel: boolean; event: dxEvent }) {
    console.log('scheduler_onAppointmentDblClick', e);

    e.cancel = true;

    if (
      e.event.target.classList.contains('dx-numberbox-spin-up-icon') ||
      e.event.target.classList.contains('dx-numberbox-spin-down-icon')
    )
      return;

    // this.scheduler.instance.deleteAppointment(e.appointmentData);
  }

  scheduler_onAppointmentClick(e: { appointmentData: TAppointment; cancel: boolean; event: dxEvent }) {
    if (
      e.event.target.classList.contains('dx-numberbox-spin-up-icon') ||
      e.event.target.classList.contains('dx-numberbox-spin-down-icon')
    ) {
      e.cancel = true;
      e.event.stopPropagation();
    }
  }

  scheduler_onAppointmentAdding(e: { appointmentData: TAppointment; cancel: boolean }) {
    console.log('scheduler_onAppointmentAdding', e);

    const date = moment(e.appointmentData.startDate).format('YYYY-MM-DD');
    const date2 = moment(e.appointmentData.endDate).format('YYYY-MM-DD');

    if (
      this.appointments.some(app => app.data.serviceDate === date) ||
      moment(date).format('YYYYMM') !== this.month ||
      moment(date).format('YYYYMM') !== moment(date2).format('YYYYMM')
    ) {
      e.cancel = true;
    }
  }

  scheduler_onAppointmentAdded(e) {
    console.log('scheduler_onAppointmentAdded', e);
    this.buildLinesFromAppointments();
  }
  scheduler_onAppointmentUpdated(e) {
    console.log('scheduler_onAppointmentUpdated', e);
    this.buildLinesFromAppointments();
  }
  scheduler_onAppointmentDeleted(e) {
    console.log('scheduler_onAppointmentDeleted', e);
    this.buildLinesFromAppointments();
  }

  appointmentData_onValueChanged(e: { value }, model: { appointmentData: TAppointment }) {
    console.log('appointmentData_onValueChanged', e, model);

    const app = this.updateAppointment(model.appointmentData);
    this.scheduler.instance.updateAppointment(model.appointmentData, app);
  }

  buildAppointment(sl?: TServiceLine): TAppointment {
    return this.updateAppointment({
      visible: true,
      allDay: true,
      //
      startDate: oc(sl).serviceDate(),
      endDate: oc(sl).serviceDateEnd() || oc(sl).serviceDate(),
      text: ['Units: ' + oc(sl).unitCount(0), 'Amount: ' + oc(sl).chargeAmount(0)].join('; \n'),
      // description: JSON.stringify(sl),
      //
      data: sl,
    });
  }

  createAppointment(date: string) {
    const sl: TServiceLine = {
      serviceDate: date,
      unitCount: 1,
      chargeAmount: this.rate,
    };

    this.scheduler.instance.addAppointment(this.buildAppointment(sl));
  }

  incAppointment(appointment: TAppointment) {
    appointment.data.unitCount += 1;
    const app = this.updateAppointment(appointment);
    this.scheduler.instance.updateAppointment(appointment, app);
  }

  updateAppointment(app: TAppointment) {
    app.data.chargeAmount = +(this.rate * app.data.unitCount).toFixed(2);
    app.text = ['Units: ' + oc(app.data).unitCount(0), 'Amount: ' + oc(app.data).chargeAmount(0)].join('; \n');
    return app;
  }

  cellHasApp(data: { startDate }) {
    return this.appointments.some(
      app => utc(data.startDate).format('YYYY-MM-DD') === utc(app.startDate).format('YYYY-MM-DD'),
    );
  }

  cellHasAuth(data: { startDate }) {
    return this.authDateUnits.has(utc(data.startDate).format('YYYY-MM-DD'));
  }

  cellAuthUnits(data: { startDate }) {
    return this.authDateUnits.get(utc(data.startDate).format('YYYY-MM-DD'));
  }

  cellSignUnits(data: { startDate }) {
    return this.signsDateUnits.get(utc(data.startDate).format('YYYY-MM-DD'));
  }

  buildLinesFromAppointments() {
    this.claimData.services = this.appointments.map(app => app.data);
    this.recalcFormsValues();
  }

  removeAppointment(e, data: { startDate }) {
    const appointments = this.appointments.filter(
      app => moment(app.startDate).format('YYYY-MM-DD') === moment(data.startDate).format('YYYY-MM-DD'),
    );

    for (const appointment of appointments) {
      this.scheduler.instance.deleteAppointment(appointment);
    }

    e.stopPropagation();
  }

  recalcFormsValues() {
    let total = 0;

    this.claimData.services.forEach(sl => {
      const amount = +(this.rate * oc(sl).unitCount(0)).toFixed(2);
      total += amount;
      sl.chargeAmount = amount;
    });

    this.claimData.chargeAmount = +total.toFixed(2);
  }

  cleanUp() {
    this.appointments = [];
    this.buildLinesFromAppointments();
  }

  resetForm() {
    this.ui.showLoading();
    void this.buildForm$()
      .pipe(
        tap(() => {
          this.buildAppointmentsFromLines();
        }),
      )
      .toPromise()
      .finally(() => this.ui.hideLoading());
  }

  submit() {
    // console.log(this.claimData);

    if (!this.claimData.services.length) {
      notify('Claim has no Service Lines', 'warning', 5000);
      return;
    }

    if (this.claimData.services.some(sl => oc(sl).unitCount(0) === 0)) {
      notify('Service Line has no units', 'warning', 5000);
      return;
    }

    if (this.claimData.services.some(sl => isEmpty(sl.serviceDate))) {
      notify('Service Line has no date', 'warning', 5000);
      return;
    }

    this.ui.showLoading();
    void this.api
      .submitClaimV2(this.claimData, this.correctionType, this.isTest ? 'T' : 'P')
      .pipe(
        map(({ claimSetId }) => claimSetId),
        tap(() => notify('Claim has been processed', 'success', 5000)),
        tap(claimId => this.dialogRef.close(claimId)),
        catchError(err => of(notify(err.message, 'error', 10_000))),
      )
      .toPromise()
      .finally(() => this.ui.hideLoading());
  }
}
